import React, { useEffect, useRef } from "react";
import { HashLink as Link } from "react-router-hash-link";
import gsap from "gsap";

import "../styles/Start.scss";

import { ReactComponent as WaveTop } from "../svgs/waveTop.svg";
import { ReactComponent as WaveBottom } from "../svgs/waveBottom.svg";
import { ReactComponent as BusinessSvg } from "../svgs/start.svg";

import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

function Start() {
  const svgWrapper = useRef(null);
  const textWrapper = useRef(null);

  useEffect(() => {
    const [elements] = svgWrapper.current.children;
    const text = textWrapper.current.children;

    const hands = elements.getElementById("hands");
    const document = elements.getElementById("document");

    gsap.set([...document.children, hands, text], {
      autoAlpha: 0,
    });

    const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

    tl.fromTo(
      document.children,
      { y: "+=300" },
      { duration: 1, y: "-=300", autoAlpha: 1 }
    ).fromTo(hands, { y: "-=300" }, { duration: 1, y: "+=300", autoAlpha: 1 });

    const tl2 = gsap.timeline({ defaults: { ease: "power3.inOut" } });
    tl2.fromTo(
      text,
      { x: "-=300" },
      { duration: 1, x: "+=300", stagger: 0.2, autoAlpha: 1 }
    );
  }, []);

  return (
    <div className="startContainer" id="start">
      <WaveTop className="waveTop" />
      <div className="startLeftSide" ref={textWrapper}>
        <h1>Help your business grows faster than ever</h1>
        <p>
          Win situation is when your business website grows faster than ever.
        </p>
        <Link smooth to="/#clients">
          Get Started <ArrowForwardIcon className="arrow" />
        </Link>
      </div>

      <div className="startRightSide" ref={svgWrapper}>
        <BusinessSvg />
      </div>
      <WaveBottom className="waveBottom" />
    </div>
  );
}

export default Start;
